<app-table
  [(focusYear)]="focusYear"
  (focusYearChange)="focusYearChanged(table)"
  [columns]="columns"
  [editable]="true"
  [firstColumnFrozen]="true"
  [focusYearRangeStart]="focusYearRangeStart"
  [hasFocusYear]="true"
  [sortField]="'date'"
  #table>
  <ng-template
    (onClick)="addLastYearsPublicHoliday()"
    appToolbarButton
    icon="fal fa-calendar-plus"
    labelKey="PUBLIC_HOLIDAYS.ADD_LAST_YEARS_HOLIDAYS"></ng-template>
</app-table>
